import React from "react";
import pattern1 from "../assets/images/pattern-1.svg";

const Footer = () => {
  return (
    <>
      <div className="footer wf-section">
        <div className="main-container">
          <div className="footer-top-contents">
            <div className="container-small footer-text">
              <p className="large-text">
                1to1help is India's leading Employee Assistance Program (EAP)
                service provider with a reputation for quality with integrity.
                We support organizations improve employee well-being, through a
                variety of programmes. We are a global support Partner of 750+
                companies covering of 4.5 million people. Certified in ISO
                9001:2013 - Quality Management System Certified ISO 27001:2013 -
                Information Security System, 1to1help also has the largest pool
                of counsellors (200+) in India with 20+ years of experience &
                650,000+ counselling sessions conducted. Our global partners
                incude Lifeworks (formerly Morneau Shepell) and Lifespeak.
              </p>
            </div>
          </div>
          <div className="footer-bottom-contents">
            <div className="small-text">
              <strong>2023 ©1to1help.net</strong>
            </div>
            <div className="small-text">
              <a href="https://1to1help.net/termsnconditions">
                <strong>Terms and Conditions</strong>
              </a>
              <strong> | </strong>
              <a href="https://1to1help.net/privacypolicy">
                <strong>Privacy Policy</strong>
              </a>
            </div>
          </div>
        </div>
        <img loading="lazy" src={pattern1} alt="" className="footer-pattern" />
      </div>
    </>
  );
};

export default Footer;
